import { effects, registerEventHandler } from 'reffects';
import { globals } from 'reffects-batteries';
import { state } from 'reffects-store';
import { registerHttpCacheEvents } from 'events/cache';

function parsePayload(payload) {
  if (typeof payload === 'string') {
    return { featureName: payload };
  }
  return payload;
}

export default function registerFeatureEvents() {
  const cacheEvents = registerHttpCacheEvents(
    'FEATURE',
    function composeFeatureCacheKeyFromPayload(payload) {
      return `feature:${payload.featureName}`;
    },
    function httpGetEffectFromPayload(payload) {
      const {
        source: { country, vertical, id },
        featureName,
      } = payload;
      const url = `index.php/api/feature_flags/${featureName}/check?source=${country}_${vertical}_${id}`;
      return {
        url,
      };
    },
    function parseFeatureFromHttpResponse(response) {
      return response.data.is_active;
    },
    function handleRetrievedFeature(feature, payload) {
      return state.set({
        [`features.${payload.featureName}`]: feature,
      });
    },
    { ttl: 300 * 1000 }
  );

  registerEventHandler(
    'LOAD_NEW_FEATURE',
    function loadNewFeature(
      {
        globals: {
          trovitData: {
            source: { countryId: country, verticalId: vertical, sourceId: id },
          },
        },
      },
      payload
    ) {
      const { featureName } = parsePayload(payload);
      const source = { country, vertical, id };

      return effects.dispatch(cacheEvents.retrieve, { featureName, source });
    },
    [globals.get('trovitData')]
  );
}
